import { combineReducers } from 'redux';

import menuReducer from './menu';
import authReducer from "./auth";
import appliedJobsReducer from './appliedJobs';
import skillReducer from './skills';
import jobReducer from './job';
import candidateReducer from './candidate';

const appReducer = combineReducers({
  customization: menuReducer,
  auth: authReducer,
  appliedJobs: appliedJobsReducer,
  skills: skillReducer,
  jobs: jobReducer,
  candidates: candidateReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = {}
  }
  return appReducer(state, action)
}

export default rootReducer;
